/* Bodega de Arte v09: featured watercolor additions. No catalog changes. */
(() => {
  const targets = [
    'Estuche Acuarela Cotman 6 piezas',
    'Estuche Metálico de Acuarela Venezia Maimeri 12 Pastillas',
    'Estuche de Acuarelas Profesional ATL y pincel'
  ];
  const normalize = s => (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const money = cents => new Intl.NumberFormat('es-MX', {style:'currency',currency:'MXN'}).format(Number(cents)/100);
  const make = (tag, className, value) => { const e=document.createElement(tag); if(className)e.className=className; if(value)e.textContent=value; return e; };
  async function findProduct(title) {
    const query = title.replace(/\s+/g,' ').trim();
    const url = `${window.Shopify?.routes?.root || '/'}search/suggest.json?${new URLSearchParams({'q':query,'resources[type]':'product','resources[limit]':'10','resources[options][unavailable_products]':'show'})}`;
    const res=await fetch(url,{credentials:'same-origin'});
    if(!res.ok) throw new Error('Shopify search unavailable');
    const products=(await res.json()).resources?.results?.products || [];
    return products.find(p=>normalize(p.title)===normalize(title)) || null;
  }
  function productCard(p, slider, i) {
    const li=make('li','grid__item slider__slide bda-watercolor-card');
    li.id=`${slider.id}-watercolor-${i}`;
    const card=make('div','card-wrapper product-card-wrapper underline-links-hover');
    const a=make('a','full-unstyled-link bda-watercolor-link');
    a.href=p.url;
    const imageBox=make('div','bda-watercolor-image');
    if(p.featured_image?.url || p.image) {
      const img=document.createElement('img'); img.src=p.featured_image?.url || p.image;
      img.alt=p.title; img.loading='lazy'; img.decoding='async'; imageBox.append(img);
    }
    a.append(imageBox,make('div','bda-watercolor-title',p.title),make('div','bda-watercolor-price',money(p.price)));
    card.append(a);li.append(card);return li;
  }
  async function init(slider) {
    if(slider.dataset.bdaLoaded) return;
    slider.dataset.bdaLoaded='true';
    const present=new Set([...slider.querySelectorAll('a[href*="/products/"]')].map(a=>a.href.split('?')[0].split('/products/')[1]).filter(Boolean));
    for(let i=0;i<targets.length;i++) {
      try {
        const p=await findProduct(targets[i]);
        if(!p) {console.info('[Bodega de Arte] No se encontró coincidencia exacta:',targets[i]);continue;}
        const handle=(p.handle || p.url.split('/products/')[1] || '').split('?')[0];
        if(present.has(handle))continue;
        slider.append(productCard(p,slider,i));present.add(handle);
      } catch(e) {console.warn('[Bodega de Arte] No se pudo buscar:',targets[i],e);}
    }
    const component=slider.closest('slider-component');
    const total=component?.querySelector('.slider-counter--total');
    if(total)total.textContent=slider.children.length;
    if(component && typeof component.initPages === 'function')component.initPages();
  }
  function boot(){document.querySelectorAll('[data-bda-watercolors="true"]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
})();
